module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/store_images/5@2x_c2c0f98f081173f4ac8252868175d0b0.png";